import * as Mod1 from "./discourse/admin-discourse-community-graph-plugin-route-map";
import * as Mod2 from "./discourse/community-graph-preferences-route-map";
import * as Mod3 from "./discourse/connectors/user-preferences-nav/community-graph-preferences.gjs";
import * as Mod4 from "./discourse/controllers/discourse-community-graph";
import * as Mod5 from "./discourse/discourse-community-graph-route-map";
import * as Mod6 from "./discourse/initializers/discourse-community-graph-admin-plugin-configuration-nav";
import * as Mod7 from "./discourse/modifiers/dcg-dismiss-on-outside";
import * as Mod8 from "./discourse/routes/discourse-community-graph";
import * as Mod9 from "./discourse/templates/discourse-community-graph";
import * as Mod10 from "./discourse/templates/preferences/community-graph";
const compatModules = {
  "discourse/admin-discourse-community-graph-plugin-route-map": Mod1,
  "discourse/community-graph-preferences-route-map": Mod2,
  "discourse/connectors/user-preferences-nav/community-graph-preferences": Mod3,
  "discourse/controllers/discourse-community-graph": Mod4,
  "discourse/discourse-community-graph-route-map": Mod5,
  "discourse/initializers/discourse-community-graph-admin-plugin-configuration-nav": Mod6,
  "discourse/modifiers/dcg-dismiss-on-outside": Mod7,
  "discourse/routes/discourse-community-graph": Mod8,
  "discourse/templates/discourse-community-graph": Mod9,
  "discourse/templates/preferences/community-graph": Mod10,
};
export { compatModules };
export default compatModules;
